import type React from 'react';

import { SettingsRounded } from '@mui/icons-material';
import { Box } from '@mui/material';
import { AnalyticsIdentityBridge, AnalyticsPageTrackingBridge } from '@ragu-components/ord-analytics';
import { AppBar, UserMenu, UserMenuItem } from '@ragu-components/ord-components';
import { Layout as RaLayout } from 'react-admin';
import { useNavigate } from 'react-router';

import { TaskNotification } from '../Resources/admin';

import { Menu } from './Menu';
import { Routes } from './Routes';

import type { LayoutProps } from 'react-admin';

export const Layout = (props: LayoutProps): React.ReactElement => {
  const navigate = useNavigate();

  return (
    <>
      <AnalyticsIdentityBridge />
      <AnalyticsPageTrackingBridge />
      <RaLayout
        {...props}
        appBar={() => (
          <AppBar
            userMenu={
              <Box display='flex' alignItems='center' gap={1}>
                <TaskNotification />
                <UserMenu>
                  <UserMenuItem
                    onClick={() => {
                      void navigate(Routes.settings);
                    }}
                    label='ord.settings.title'
                    icon={<SettingsRounded />}
                  />
                </UserMenu>
              </Box>
            }
          />
        )}
        menu={Menu}
      />
    </>
  );
};
